import React, { useState } from "react";
import { FaLock, FaUnlockAlt } from "react-icons/fa";
import Swal from "sweetalert2";
import { api_url } from "../../../Constants/web_services";

function ChangePassword() {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const validateForm = () => newPassword === confirmPassword;

  const togglePasswordVisibility = (type) => {
    if (type === 'old') {
      setShowOldPassword(!showOldPassword);
    } else if (type === 'new') {
      setShowNewPassword(!showNewPassword);
    } else if (type === 'confirm') {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Passwords do not match",
      });
      return;
    }

    Swal.fire({
      title: "Are you sure you want to change your Password?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, change it!",
      cancelButtonText: "No, cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const updatedUserData = {
            oldPassword,
            newPassword,
          };

          const token = localStorage.getItem('token');

          const response = await fetch(api_url + `/api/changepassword`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify(updatedUserData),
          });

          if (response.ok) {
            Swal.fire({
              icon: "success",
              title: "Password changed successfully",
            });
            setOldPassword("");
            setNewPassword("");
            setConfirmPassword("");
          } else {
            Swal.fire({
              icon: "error",
              title: "Failed to change password",
            });
          }
        } catch (error) {
          console.error("Network error:", error);
        }
      }
    });
  };

  return (
    <div className="content-admin-main my-5">
      <div className="aon-admin-heading">
        <h4 className="s-16 fw-700 text-022279">Password Change</h4>
      </div>

      <div className="card aon-card border-0 shadow">
        <div className="card-body aon-card-body">
          <div className="sf-bd-data-tb-head">
            <form onSubmit={handleChangePassword}>
              <div className="row">
                <div className="row m-1">
                  <div className="col-md-4 p-2">
                    <div className="input-group mb-3">
                      <span
                        className="input-group-text  bg-white aon-input-icon border-dee2e6"
                        id="basic-addon1"
                        style={{ color: "#022279" }}
                      >
                        <FaUnlockAlt />
                      </span>
                      <input
                        type={showOldPassword ? "text" : "password"}
                        placeholder="Old Password"
                        value={oldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                        className="form-control border-start-0 box-shadow-none border-dee2e6"
                        aria-describedby="basic-addon1"
                      />
                      <span
                        className="input-group-text  bg-white aon-input-icon border-dee2e6"
                        id="basic-addon1"
                      >
                        <i
                          onClick={() => togglePasswordVisibility('old')}
                          className={`fa ${showOldPassword ? "fa-eye text-danger" : "fa-eye-slash text-success"}`}
                        ></i>
                      </span>
                    </div>
                  </div>
                  <div className="col-md-4 p-2">
                    <div className="input-group mb-3">
                      <span
                        className={`input-group-text  bg-white aon-input-icon border-dee2e6 ${validateForm() ? "" : "border-danger"} ${newPassword ? "border-success" : ""}`}
                        id="basic-addon1"
                        style={{ color: "#022279" }}
                      >
                        <FaLock />
                      </span>
                      <input
                        className={`form-control sf-form-control p-2 ${validateForm() ? "" : "border-danger"} ${newPassword ? "border-success" : ""}`}
                        name="newPassword"
                        type={showNewPassword ? "text" : "password"}
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                      <span
                        className={`input-group-text bg-white aon-input-icon border-dee2e6 ${validateForm() ? "" : "border-danger"} ${newPassword ? "border-success" : ""}`}
                        id="basic-addon1"
                      >
                        <i
                          onClick={() => togglePasswordVisibility('new')}
                          className={`fa ${showNewPassword ? "fa-eye text-danger" : "fa-eye-slash text-success"}`}
                        ></i>
                      </span>
                    </div>
                  </div>
                  <div className="col-md-4 p-2">
                    <div className="input-group mb-3">
                      <span
                        className={`input-group-text bg-white aon-input-icon border-dee2e6 ${validateForm() ? "" : "border-danger"} ${confirmPassword ? "border-success" : ""}`}
                        id="basic-addon1"
                        style={{ color: "#022279" }}
                      >
                        <FaLock />
                      </span>
                      <input
                        className={`form-control sf-form-control text-primary ${validateForm() ? "" : "border-danger"} ${confirmPassword ? "border-success" : ""}`}
                        name="confirmPassword"
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                      <span
                        className={`input-group-text bg-white aon-input-icon border-dee2e6 ${validateForm() ? "" : "border-danger"} ${confirmPassword ? "border-success" : ""}`}
                        id="basic-addon1"
                        style={{ color: "#022279" }}
                      >
                        <i
                          onClick={() => togglePasswordVisibility('confirm')}
                          className={`fa ${showConfirmPassword ? "fa-eye text-danger" : "fa-eye-slash text-success"}`}
                        ></i>
                      </span>
                    </div>
                  </div>
                  <button type="submit" className="site-button">
                    Change Password
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
